module.exports = __webpack_public_path__ + "img/cloudy-day-2.b931d84d.svg";